import React from 'react'
import injectStyles from 'react-jss'

import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { switchOrderBy } from '../../../utils'
import { styles } from './styles'

const EnhancedTableHead = props => {
  const { classes, order, orderBy, onRequestSort, headCells } = props
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }
  const currentColumn = (orderBy, header) => {
    return orderBy
      ? Boolean(orderBy.search(switchOrderBy(header).toUpperCase()) + 1)
      : false
  }
  return (
    <TableHead className={classes.header}>
      <TableRow>
        {headCells.map(headCell => {
          const isThisColumn = currentColumn(orderBy, headCell.id)
          return (
            <TableCell
              key={headCell.id}
              align="center"
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={isThisColumn ? order.toLowerCase() : false}
            >
              <TableSortLabel
                hideSortIcon={!headCell.sortable}
                active={headCell.sortable}
                direction={isThisColumn ? order.toLowerCase() : 'desc'}
                onClick={
                  headCell.sortable ? createSortHandler(headCell.id) : null
                }
              >
                {headCell.label}
                {headCell.sortable ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'DESC'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

export default injectStyles(styles)(EnhancedTableHead)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/MasterSchedule/EnhancedTable/Components/EnhancedTableHead/index.js